import EmptyRecords from '@/views/components/Common/EmptyRecords';
import CommonModal from '@/views/components/Modals/CommonModal';
import ScrollPagination from '@/views/components/Paginations/ScrollPagination';
import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLADClaimItemsInProgress,
  updateLossAndDamageClaimDetailsInProgress,
} from '../../../../../../redux/Claims/LossAndDamage/LossAndDamageClaimsActions';
import { LADCovertDatesFromMomentToAPIType } from '../../../../../../utilz/PreClaimsUtils';
import Button from '../../../../../components/Buttons/Button';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import AddProductFullModal from '../../../../common/AddProductFull/AddProductFullModal';
import LADEmailStatus from '../../EmailStatus/LADEmailStatus';
import LADClaimsItemCard from './LADClaimsItemCard';

const LADClaimsItemsTab = () => {
  const dispatch = useDispatch();
  const [addProductModal, setAddProductModal] = useState(false);
  const [addProductModalIndex, setAddProductModalIndex] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [itemList, setItemList] = useState([]);
  const claimDetails = useSelector((state) => state.lossAndDamage.claimDetails);
  const claimItems = useSelector((state) => state.lossAndDamage.claimItems);
  const [openEmailStatus, setOpenEmailStatus] = useState(false);

  useEffect(() => {
    if (claimItems.success && claimItems?.data) {
      setItemList(claimItems.data.map((data) => ({ ...data, isNew: false })));
    }
  }, [claimItems]);

  const setEditMode = (index, val) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[index].editMode = val;
    setItemList(itemListLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const itemListLocal = cloneDeep(itemList);
    if (isNew) {
      itemListLocal.splice(index, 1);
    } else {
      itemListLocal[index] = {
        ...itemListLocal[index],
        editMode: false,
      };
    }
    setItemList(itemListLocal);
  };

  const handleSubmit = (data) => {
    let payload = cloneDeep(claimDetails.data);
    payload.claimItem = [{ ...data, dirtyFlag: data.isNew ? 'I' : 'U' }];
    payload = LADCovertDatesFromMomentToAPIType(payload);
    payload.section = 'ITEMS';
    payload.pageIndex = pageIndex;
    dispatch(updateLossAndDamageClaimDetailsInProgress(payload));
  };

  const handleDelete = (index) => () => {
    let payload = cloneDeep(claimDetails?.data);
    payload.claimItem = [{ ...itemList[index], dirtyFlag: 'D' }];
    payload = LADCovertDatesFromMomentToAPIType(payload);
    payload.section = 'ITEMS';
    payload.pageIndex = pageIndex;
    dispatch(updateLossAndDamageClaimDetailsInProgress(payload));
  };

  const handleAddNew = () => () => {
    let itemListLocal = cloneDeep(itemList);
    let nextSequence = maxBy(itemListLocal, ({ itemSeq }) => Number(itemSeq));
    nextSequence = nextSequence ? nextSequence.itemSeq : 0;
    itemListLocal = [
      {
        claimKey: claimDetails?.data?.claimKey,
        itemSeq: nextSequence + 1,
        itemCode: '',
        itemQuantity: undefined,
        itemDesc: '',
        measure: '',
        itemUnitMeasure: '',
        fullRelFlag: '',
        dispositionMethod: '',
        value: undefined,
        smType: '',
        smFlag: '',
        smAmount: undefined,
        dirtyFlag: 'i',
        isNew: true,
        editMode: true,
      },
      ...itemListLocal,
    ];
    setItemList(itemListLocal);
  };

  const handleNewProductModal = (index) => {
    setAddProductModalIndex(index);
    setAddProductModal(true);
  };

  const onSelectAddressBook = (data) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[addProductModalIndex] = {
      ...itemListLocal[addProductModalIndex],
      itemCode: data.productCode,
      itemDesc: data.productDesc,
      isNew: true,
      editMode: true,
    };
    setItemList(itemListLocal);
    handleAddProductModalClose();
  };

  const handleAddProductModalClose = () => {
    setAddProductModal(false);
    setAddProductModalIndex(false);
  };

  useEffect(() => {
    if (claimDetails.data?.claimKey) {
      dispatch(
        getLADClaimItemsInProgress({
          claimKey: claimDetails.data.claimKey,
          pageIndex,
        }),
      );
    }
  }, [claimDetails.data?.claimKey]);

  const handleNextPage = () => {
    if (claimDetails.data?.claimKey) {
      const nextPageNo = pageIndex + 1;
      dispatch(
        getLADClaimItemsInProgress({
          claimKey: claimDetails.data.claimKey,
          pageIndex: nextPageNo,
        }),
      );
      setPageIndex(nextPageNo);
    }
  };

  const handleOpenEmailStatus = () => {
    setOpenEmailStatus(false);
  };

  const handleOpenEmailModel = () => {
    setOpenEmailStatus(true);
  };
  return (
    <div className="d-flex flex-direction-column h-100 overflow-hidden">
      <Row className="align-items-center pt-15 px-30" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">Claim Items</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={() => handleOpenEmailModel()}>View Email Status</Button>
            </Col>
            <Col>
              <Button onClick={handleAddNew()}>Add New Item</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      {itemList.length > 0 || claimItems.progressing ? (
        <ScrollPagination
          className="px-30 py-10 flex-1"
          loadMore={handleNextPage}
          isLoading={claimItems.progressing}
          hasMore={claimItems.data?.length < claimItems.totalRows}
          scrollOffset={30}
        >
          {itemList.map((row, index) => (
            <LADClaimsItemCard
              itemDetails={row}
              key={row.itemSeq}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
              handleNewProductModal={handleNewProductModal}
            />
          ))}
        </ScrollPagination>
      ) : (
        <EmptyRecords />
      )}
      <AddProductFullModal
        addressBookModal={addProductModal && addProductModalIndex !== false}
        onSelectAddressBook={onSelectAddressBook}
        handleAddressBookModalClose={handleAddProductModalClose}
      />
      <CommonModal
        title="Email Status"
        open={openEmailStatus}
        className="vh-80 vw-90"
        onClose={handleOpenEmailStatus}
        destroyOnClose
        customFooter={<></>}
      >
        <LADEmailStatus claimKey={claimDetails.data?.claimKey} />
      </CommonModal>
    </div>
  );
};

export default LADClaimsItemsTab;
